import { cpf, cnpj } from 'cpf-cnpj-validator'

export function validaCpfCnpj (value) {
  let cpf_num = ''
  if (value.length > 0) {
    cpf_num = value
  }
  let strCPF = new String(cpf_num.replace(/\D/g, ''))
  if (strCPF.length <= 11) {
    return cpf.isValid(strCPF)
  }
  return cnpj.isValid(strCPF)
}
export function isEmpty (value) {
  if (value == null || value == '' || value==undefined) {
    return true;
  }
  if (typeof value == 'object') {
    return Object.entries(value).length === 0
  }
  if (typeof value == typeof Array) {
    return value.length > 0
  }
  return false;
}
export function existsProp(local,prop){
  return Object.prototype.hasOwnProperty.call(local, prop)
}
export function isDataURL(s) {
    return s.match(/^data:image\/(?:gif|png|jpeg|bmp|webp)(?:;charset=utf-8)?;base64,(?:[A-Za-z0-9]|[+/])+={0,2}/ig);
}
export function validaCpf (value) {
  let cpf_num = ''
  if (value.length > 0) {
    cpf_num = value
  }
  let strCPF = new String(cpf_num.replace(/\D/g, ''))
  if (strCPF.length <= 11) {
    return cpf.isValid(strCPF)
  }
}
export function validaCnpj (value) {
  let cpf_num = ''
  if (value==undefined || value.length <= 13) {
    return false;
  }
  cpf_num = value
  let strCPF = new String(cpf_num.replace(/\D/g, ''))
  return cnpj.isValid(strCPF)
}

export function formatCnpj (value) {
  return cnpj.format(value);
}
export function formatCpf (value) {
  return cpf.format(value);
}

export function toFloat (value, fixed) {
  if (typeof value == 'number') {
    value = value.toString();
  } else {
    value = value.toString().replace(/\./g, '')
  }
  let number = value;
  // console.log('value=',value);
  number = number.replace(',', '.');
  // console.log('number=',number);
  number = parseFloat(number);
  return (fixed) ? number.toFixed(2) : number;
}
export function isFloat(n){
  return n === +n && n !== (n|0);
}

export function parseDateBr(date){
  if(typeof date != typeof new Date) {
    if(date==null || date.length<=0 || date==undefined) {
      return date
    }
    date = new Date(date)
  }
  let data = date.getFullYear() 
  data +='-' 
  data += ('00' + (date.getMonth()+1)).slice(-2)
  data += '-' 
  data += ('00' + date.getDate()).slice(-2) 
  data += ' ' 
  data += ('00' + date.getHours()).slice(-2)
  data += ':' 
  data += ('00' + date.getMinutes()).slice(-2)
  data += ':' 
  data += ('00' + date.getSeconds()).slice(-2)
  return data

}

export function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
    return v.toString(16);
  });
}